import React from 'react';

import TextInput, {TextInputProps} from 'ui-library/inputs/TextInput';
import insertTextFromPaste from 'util/insertTextFromPaste';
import {InputChangeEvent} from 'util/Types';

export interface MultiTextInputProps extends Omit<TextInputProps, 'onChange'> {
  onChange: (multiValues: Array<string>, value: string, e: InputChangeEvent) => void;
}

/**
 * Text input that splits input into multiple strings, split by commas, with trailing/leading whitespace removed.
 *
 * Calls the onChange prop with an array of the split input strings, the single entire input string, and the
 * original event.
 *
 * Note: currently does not support escaping commas user may not want to split on.
 */
export default function MultiValueTextInput(props: MultiTextInputProps): JSX.Element {
  function onChange(e: InputChangeEvent): void {
    const value = e.target.value;
    props.onChange(
      value
        .split(',')
        .map((term) => term.trim())
        .filter((term) => term),
      value,
      e
    );
  }

  return <TextInput {...props} onChange={onChange} onPaste={insertTextFromPaste} />;
}

MultiValueTextInput.defaultProps = {
  placeholder: 'Comma-separated values',
};
